export enum ProductCodeEnum {
    osago = "Астро-Волга",
    osaga = "Аско",
}

export class ProductCode {
    public readonly title: string;
    public readonly value: string;

    constructor(
        value?: string,
    )
    constructor(
        title?: string,
        value?: string,
    )
    constructor(
        title?: string,
        value?: string,
    )
    constructor(
        titleOrValue: string = "",
        value: string = "",
    ) {
        if (titleOrValue && value) {
            this.title = titleOrValue;
            this.value = value;
        } else if (titleOrValue) {
            this.value = titleOrValue;
            this.title = this.value === "osago"
                ? ProductCodeEnum.osago
                : ProductCodeEnum.osaga;
        } else {
            this.title = titleOrValue;
            this.value = value;
        }
    }
}
